import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { GettingStartedResource } from '~/resources';

export const useStepSave = (emit) => {
  const { t } = useI18n({ useScope: 'global' });
  const saving = ref(false);
  const serverErrors = ref([]);

  const serverMessages = (body = {}) => {
    const messages = [body.message, body.alert, ...Object.values(body.errors ?? {}).flat()].filter((message) => typeof message === 'string' && message);

    return messages.length ? messages : [t('unexpected_error')];
  };

  const failures = (results) => results.filter(({ status }) => status === 'rejected').flatMap(({ reason }) => serverMessages(reason?.responseJSON));

  const finishStep = async (organizationId, substep, options) => {
    const response = await GettingStartedResource.updateSubstep({ organizationId }, { substep, status: 'finished' }, options);

    return response.success ? [] : [t('unexpected_error')];
  };

  const run = async (persist) => {
    saving.value = true;
    serverErrors.value = [];

    try {
      serverErrors.value = await persist();
    } catch (error) {
      serverErrors.value = serverMessages(error?.responseJSON);
    } finally {
      saving.value = false;
    }

    if (!serverErrors.value.length) {emit('saved');}
  };

  return { saving, serverErrors, serverMessages, failures, finishStep, run };
};
